<template>
  <div class="stepper">
    <!-- <div class="pull-right">
      <span @click="$i18n.locale = 'en'">EN</span> &nbsp;
      <span @click="$i18n.locale = 'de'">DE</span>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <br />
      <br />
    </div>-->
    <ul class="list-unstyled multi-steps">
      <li
        @click="backToCategories()"
        :class="[{'is-active': getActiveStep === 0}, brand + '-progress-li']"
      >
        {{ $t("message.category") }}
        <br />
        <span class="selected">{{ category }}</span>
      </li>
      <li
        @click="backToModels()"
        :class="[{'is-active': getActiveStep === 1}, brand + '-progress-li']"
      >
        {{ $t("message.model") }}
        <br />
        <span class="selected">{{ model }} {{ year }}</span>
      </li>
      <li
        v-if="hasColor"
        @click="backToColors()"
        :class="[{'is-active': getActiveStep === 2}, brand + '-progress-li']"
      >
        {{ $t("message.color") }}
        <br />
        <span class="selected">{{ color }}</span>
      </li>
      <li
        @click="backToUnits()"
        :class="[{'is-active': getActiveStep === 3}, brand + '-progress-li']"
      >
        {{ $t(`message.unit`) }}
        <br />
        <span class="selected">{{ unit.name }}</span>
      </li>
    </ul>
    <div class="go-back text-right" v-show="getActiveStep > 0">
      <button @click="goBack()" type="button" class="btn btn-sm" :class="`btn-action-${brand}`">
        <img class="back-icon" src="https://teilecdn.com/assets/icons/left-arrow.svg" />
        {{ $t("message.goBack") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
  name: 'ProgressBar',
  computed: {
    ...mapGetters(['getActiveStep']),
    hasColor: function () {
      if (
        this.brand === 'ktm' ||
        this.brand === 'husky' ||
        this.brand === 'gasgas'
      )
        return false;
      else return true;
    },
    brand: {
      get() {
        return this.$store.state.selectedbrand;
      },
    },
    category: {
      get() {
        return this.$store.state.selectedCategory;
      },
    },
    year: {
      get() {
        return this.$store.state.selectedYear;
      },
    },
    model: {
      get() {
        return this.$store.state.selectedModel;
      },
    },
    color: {
      get() {
        return this.$store.state.selectedColor;
      },
    },
    unit: {
      get() {
        return this.$store.state.selectedUnit;
      },
    },
    brand: {
      get() {
        return this.$store.state.brand;
      },
    },
  },
  methods: {
    ...mapActions([
      'backToCategories',
      'backToModels',
      'backToColors',
      'backToUnits',
      'goBack',
    ]),
  },
};
</script>

<style lang="scss">
@import '@/styles/ProgressBar.scss';
</style>
